import { postData, getData, putData } from '@/utils/fetch';
import { OrderListQuery, OrderListItem, OrderListBind } from './type';
import { getOrgIdPath } from '@/utils/tool';

const baseUrl = '/api/console/';

// 查询亚马逊订单列表
export function getAmazonOrder(params: OrderListQuery) {
  return getData<{ list: OrderListItem[] }>(baseUrl + 'marketplace/amazon-order/list', params);
}

// 订单绑定
export function amazonOrderBind(params: OrderListBind) {
  return putData(baseUrl + 'sub' + getOrgIdPath('/marketplace/amazon-order/binding'), {
    params,
  });
}
// 获取可购买IP查询
export function getIpPublist(orgId: string) {
  return getData<{ ip: string; loc: string; ipId: string }[]>(
    baseUrl + `sub/o-${orgId}/Email/ind_ip/publist`,
  );
}
// 可购买域名查询
export function getDomail(orgId: string) {
  return getData<{ name: string }[]>(baseUrl + `sub/o-${orgId}/Email/domail/passedlist`);
}

function pushPath(isWeb: boolean) {
  const str = isWeb ? 'web' : 'app';
  return `/api/${str}-push/portalapi/v1`;
}
//获取应用列表
export const getAppList = (isWeb = false, orgId: string) => {
  return getData<any>(
    pushPath(isWeb) + '/portal-appdev/app/org_appList',
    { pageIndex: 1, pageSize: 10000 },
    true,
    {
      orgId: orgId,
    },
  );
};
